import { MinusIcon, PlusIcon } from './Icons';

export default function StoryPointsInput({ value, onChange, placeholder = '0' }) {
  const numValue = value === '' || value == null ? '' : Number(value);

  const handleDecrement = () => {
    if (numValue === '' || numValue <= 0) return;
    onChange(String(numValue - 1));
  };

  const handleIncrement = () => {
    onChange(String(numValue === '' ? 1 : numValue + 1));
  };

  const handleInputChange = (e) => {
    const raw = e.target.value;
    if (raw === '') {
      onChange('');
      return;
    }
    const n = parseInt(raw, 10);
    if (!isNaN(n) && n >= 0) {
      onChange(String(n));
    }
  };

  return (
    <div className="sp-input">
      <button
        type="button"
        className="sp-input-btn"
        onClick={handleDecrement}
        disabled={numValue === '' || numValue <= 0}
      >
        <MinusIcon size={14} />
      </button>
      <input
        className="sp-input-field"
        type="text"
        inputMode="numeric"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
      <button
        type="button"
        className="sp-input-btn"
        onClick={handleIncrement}
      >
        <PlusIcon size={14} />
      </button>
    </div>
  );
}
